// Client-side WebAuthn (passkey) helpers. Each runs the browser ceremony and
// posts the result to the backend for verification.
import { startRegistration, startAuthentication, browserSupportsWebAuthn } from '@simplewebauthn/browser';

export const passkeysSupported = () => {
  try { return browserSupportsWebAuthn(); } catch { return false; }
};

// Add a passkey to the signed-in account.
export async function registerPasskey(label) {
  const optRes = await fetch('/api/auth/passkey/register/options', {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: '{}',
  });
  const optionsJSON = await optRes.json();
  if (!optRes.ok) throw new Error(optionsJSON.error || 'Could not start passkey setup.');

  const attResp = await startRegistration({ optionsJSON });

  const verRes = await fetch('/api/auth/passkey/register/verify', {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ response: attResp, label }),
  });
  const data = await verRes.json();
  if (!verRes.ok || !data.ok) throw new Error(data.error || 'Could not add passkey.');
  return data;
}

// Sign in with a passkey. `email` is optional (scopes the credential list);
// omit it to let the browser offer any discoverable passkey.
export async function authenticatePasskey(email) {
  const optRes = await fetch('/api/auth/passkey/login/options', {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email: email || undefined }),
  });
  const optionsJSON = await optRes.json();
  if (!optRes.ok) throw new Error(optionsJSON.error || 'Could not start passkey sign-in.');

  const authResp = await startAuthentication({ optionsJSON });

  const verRes = await fetch('/api/auth/passkey/login/verify', {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ response: authResp }),
  });
  const data = await verRes.json();
  if (!verRes.ok || !data.ok) throw new Error(data.error || 'Passkey sign-in failed.');
  return data; // { user, permissions }
}
